import Swiper from 'swiper';
import {Pagination,Navigation, A11y, Keyboard, Autoplay} from "swiper/modules";
//import {enable} from "core-js/internals/internal-metadata";

if(document.querySelectorAll('.af-google-ratings')) {
    const sliderElements = document.querySelectorAll('.af-google-ratings');

    sliderElements.forEach(slider => {

        const swiper = new Swiper(slider.querySelector('.af-google-ratings-swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 24,
            autoplay: {
                delay: 3000,
            },
            modules: [Pagination,Navigation, A11y, Keyboard, Autoplay],
            loop: true,
            grabCursor:true,
            preventClicks:false,
            pagination: {
                el: slider.querySelectorAll('.swiper-pagination')[0],
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
        //console.log(swiper)
    });

    //Show more buttons
    const comments = document.querySelectorAll(".af-google-ratings-single-comment");
    if(comments) {
        function afToggleMoreComment(commentCurrent,action) {
            const showMoreCurrent = commentCurrent.querySelector(".af-google-ratings-single-comment-ext");
            const theRestOfTheComment = commentCurrent.querySelector(".af-google-ratings-single-comment-second-part");
            const showLessCurrent = commentCurrent.querySelector(".af-google-ratings-single-comment-retrieve");
            const commentCurrentEtc = commentCurrent.querySelector(".af-google-ratings-single-comment-etc");
            if(action === "show") {
                //Show comment
                theRestOfTheComment.classList.remove("af-google-ratings-single-comment-second-part-hidden");
                //Hiding "show more" button by adding af-google-ratings-single-comment-ext-hidden class
                showMoreCurrent.classList.add("af-google-ratings-single-comment-ext-hidden");
                //Showing "show less" button by removing af-google-ratings-single-comment-ext-hidden class
                showLessCurrent.classList.remove("af-google-ratings-single-comment-retrieve-hidden");
                //Removing 3 dots
                commentCurrentEtc.classList.add("af-google-ratings-single-comment-etc-hidden");
                //commentCurrent.parentElement.style.height = "auto";
            }
            else {
                //Show comment
                theRestOfTheComment.classList.add("af-google-ratings-single-comment-second-part-hidden");
                //Showing "show more" button by removing af-google-ratings-single-comment-ext-hidden class
                showMoreCurrent.classList.remove("af-google-ratings-single-comment-ext-hidden");
                //Hiding "show less" button by adding af-google-ratings-single-comment-ext-hidden class
                showLessCurrent.classList.add("af-google-ratings-single-comment-retrieve-hidden");
                //Showing 3 dots
                commentCurrentEtc.classList.remove("af-google-ratings-single-comment-etc-hidden");
            }
        }

        function afResizingSingleComments(singleComment = null) {
            const comments = document.querySelectorAll(".af-google-ratings-single");
            const commentsNotExpanded = Array.from(comments).filter(comment => {
                return !comment.querySelector('.af-google-ratings-single-comment-ext-hidden');
            });
            const commentsLength = comments.length;

            const standardHeight = commentsNotExpanded[0].getBoundingClientRect().height;
            for (let i = 0; i < commentsLength; i++) {
                if(comments[i] !== singleComment) {
                    comments[i].style.height = standardHeight + "px";
                    if(comments[i].querySelector(".af-google-ratings-single-comment-longer")) {
                        afToggleMoreComment(comments[i].querySelector(".af-google-ratings-single-comment-longer"),"hide");
                    }
                }
            }
            if (singleComment !== null && !(singleComment instanceof Event)) {
                if(singleComment.style.height !== "auto") {
                    singleComment.style.height = "auto";
                }
            }
            else {
                for (let i = 0; i < commentsLength; i++) {
                    comments[i].style.height = "auto";
                }
            }
        }

        function timeSince(dateString) {
            const now = new Date();
            const past = new Date(dateString);

            const diffInMs = now - past;
            const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

            const nowYear = now.getFullYear();
            const nowMonth = now.getMonth();
            const nowDay = now.getDate();

            const pastYear = past.getFullYear();
            const pastMonth = past.getMonth();
            const pastDay = past.getDate();

            let years = nowYear - pastYear;
            let months = nowMonth - pastMonth;
            let days = nowDay - pastDay;

            if (days < 0) {
                months -= 1;
                days += new Date(nowYear, nowMonth, 0).getDate(); // Days in previous month
            }

            if (months < 0) {
                years -= 1;
                months += 12;
            }

            if (years >= 1) {
                return `Vor ${years === 1 ? 'einem Jahr' : years + ' Jahren'}`;
            } else if (months >= 1) {
                return `Vor ${months === 1 ? 'einem Monat' : months + ' Monaten'}`;
            } else if (diffInDays >= 1) {
                return `Vor ${diffInDays === 1 ? 'einem Tag' : diffInDays + ' Tagen'}`;
            } else {
                return 'Heute';
            }
        }

        function afCalculateTimeDifference() {
            const timeStamp = document.querySelectorAll(".af-google-ratings-timestamp");
            const timeStampLength = timeStamp.length;

            for(let i = 0; i < timeStampLength; i++) {
                const timeStampCurrent = timeStamp[i];
                timeStampCurrent.innerHTML = timeSince(timeStampCurrent.dataset.date);
            }
        }

        window.addEventListener("load",afCalculateTimeDifference);

        window.addEventListener("load",afResizingSingleComments);
        window.addEventListener("resize",afResizingSingleComments);

        const commentsLength = comments.length;
        for (let i = 0; i < commentsLength; i++) {
            (function () {
                const commentCurrent = comments[i];
                const commentCurrentParent = comments[i].parentElement;
                const commentCurrentShow = commentCurrentParent.querySelector(".af-google-ratings-single-comment-ext");
                const commentCurrentHide = commentCurrentParent.querySelector(".af-google-ratings-single-comment-retrieve");
                if(commentCurrentShow) {
                    commentCurrentShow.addEventListener("click",function() {afResizingSingleComments(commentCurrent.parentElement)});
                    commentCurrentShow.addEventListener("click",function() {afToggleMoreComment(commentCurrent,"show")})
                }
                if(commentCurrentHide) {
                    commentCurrentShow.addEventListener("click",function() {afResizingSingleComments(commentCurrent.parentElement)});
                    commentCurrentHide.addEventListener("click",function() {afToggleMoreComment(commentCurrent,"hide")});
                }
            })();
        }
    }
}
